
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetTrialByOid, GetTrialByOidResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetTrialByOidResponse, GetTrialByOidResponse>) => response?.data?.trial;
const getError = (response?: SWRResponse<GetTrialByOidResponse, GetTrialByOidResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetTrialByOidResponse, GetTrialByOidResponse>) => ({});

const useGetTrialByOid = (query?: Partial<GetTrialByOid>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetTrialByOid(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrialByOid;